import { Toast } from 'vant'
import { Dialog } from 'vant'
import { delWeek } from '@/api/orderScheduledAt'
import { plateValidator } from '@/util/regEx.js'
export const formValidate = data => {
  if (!data.username) {
    Toast('请输入姓名')
    return false
  }
  if (!data.licensePlate) {
    Toast('请填写车牌号')
    return false
  } else if (!data.licensePlate.match(plateValidator)) {
    Toast('请正确填写车牌号')
    return false
  }
  if (!data.phone) {
    Toast('请填写手机号')
    return false
  } else if (!data.phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)) {
    Toast('请正确填写手机号')
    return false
  }
  return true
}

export const showTip = () => {
  Dialog.alert({
    title: '温馨提示',
    message: '为确保您所选的轮胎型号适配您的车型，建议您上传轮胎照片，以供后台人工核实。',
    confirmButtonText: '知道了',
    closeOnClickOverlay: true
  })
}
const getSixCouponV = (data, couponList) => {
  //获取使用的六位码优惠券
  let list = []
  let ind = 0
  for (let key in data) {
    let code = data[key]
    if (code) {
      list.push({ couponValue: couponList[ind], couponCode: code, couponTypeFlag: 2, rightId: '' }) //tyreQuantity:
    }
    ind++
  }
  return list
}
export const getPostData = state => {
  let tyreData = []
  let customerInfo = state.customerInfo
  state.buyTyre.forEach(item => {
    tyreData.push({
      productAmount: item.count,
      productId: item.id,
      productType: 4,
      productPrice: item.ind_price || item.msrp,
      cartId: item.cartId,
      gsCode: state.gs_code
    })
  })
  let customer = {
    customerMobile: customerInfo.phone,
    customerName: customerInfo.username
  }
  let coupon = []
  if (state.couponTypeFlag == 1) {
    state.preferential.forEach(item => {
      if (item.couponCode == '') {
        state.autoGetCouponFlag = true
      }
      coupon.push({
        couponValue: item.rightContent.subtractPrice,
        couponCode: item.couponCode,
        couponTypeFlag: 1,
        rightId: item.rightId
      })
    })
  } else if (state.couponTypeFlag == 2) {
    coupon = getSixCouponV(state.couponNumList, state.sixAmountList)
  } else if (state.couponTypeFlag == 3) {
    state.tyrecouponSelected.forEach(item => {
      coupon.push({
        couponCode: item.couponCode,
        couponTypeFlag: 3,
        rightId: item.id,
        tyreNo: item.tyreNo
      })
    })
  }
  let signMsg = {
    typeFlag: state.typeFlag,
    orderTypeFlag: 3,
    priceTypeFlag: 3,
    submitTypeFlag: state.active, //{1：到店订单 2：在线下单}
    reserveTime: state.active === 2 ? delWeek(state.appointTime) + ':00' : '',
    gsCode: state.gs_code,
    boUserId: state.saId,
    plate: customerInfo.licensePlate,
    fromQr: state.fromQr
  }
  let params = {
    tyre: { data: tyreData },
    customer,
    coupon,
    tyrePhoto: state.tyreImgList,
    ...signMsg
  }
  return params
}
